export default "__VITE_ASSET__BbdcElQV__"